/** 与 backend/utils/order/orderDeliveryStatus.js 口径一致 */

import { ORDER_DELIVERY_STATUS_VALUES } from './orderStatus.js';

function isLegacyCompletedBeforeFinalCostCutoff(order) {
	return Boolean(order?.uiHints?.isLegacyCompletedBeforeFinalCostCutoff);
}

export function resolveOrderDeliveryStatus(order) {
	if (!order) {
		return 'waitingDelivery';
	}

	if (order.isCompleted || isLegacyCompletedBeforeFinalCostCutoff(order)) {
		return 'logisticsComplete';
	}

	if (order.isDelivered && order.isAccepted) {
		return 'logisticsComplete';
	}

	if (order.isDelivered && !order.isAccepted) {
		return 'waitingAccept';
	}

	return 'waitingDelivery';
}

export function normalizeStoredDeliveryStatus(deliveryStatus, order = null) {
	if (order?.uiHints?.storedDeliveryStatus) {
		return order.uiHints.storedDeliveryStatus;
	}
	if (!deliveryStatus || ORDER_DELIVERY_STATUS_VALUES.includes(deliveryStatus)) {
		return deliveryStatus;
	}
	if (order) {
		return resolveOrderDeliveryStatus(order);
	}
	return deliveryStatus;
}
